import styled from 'styled-components';
import { useStyledTheme } from '@equifinance/shared';
import { CompanyStatus } from '../../contexts/brokerages';

export const StatusDefaultLabel = styled.div<{ background?: string, color?: string }>`${({ theme, background, color }) => `
  padding: 3px ${theme.padding[2]};
  background: ${background || theme.colours.primary[10]};
  color: ${color || theme.colours.primary[1]};
  display: flex;
  flex-wrap: wrap;
  border-radius: ${theme.padding[1]};
  font-weight: ${theme.fontWeight.bold};
  width: fit-content;
  line-height: ${theme.padding[4]};
  justify-content: center;
  align-items: center;
  gap: ${theme.padding[1]};
`}`;

export default function BrokerageStatusLabel({ status }: { status: keyof typeof CompanyStatus }) {
  const theme = useStyledTheme();

  const colors = (status: keyof typeof CompanyStatus) => {
    switch (status) {
      case 'Active':
        return [theme.colours.primary[3], theme.colours.neutral[10]];
      case 'Inactive':
        return [theme.colours.neutral[4], theme.colours.neutral[10]];
      case 'Rejected':
        return [theme.colours.neutral[2], theme.colours.neutral[10]];
      case 'Suspended':
        return [theme.colours.primary[7], theme.colours.primary[1]];
      default: return [theme.colours.primary[3], theme.colours.neutral[10]];
    }
  };

  const [background, color] = colors(status);

  return (
    <StatusDefaultLabel background={background} color={color}>
      {status}
    </StatusDefaultLabel>
  );
}
